import { Outlet } from '@tanstack/react-router';

export function AppShell() {
  // Clean, minimal - no sidebar, just content
  return <Outlet />;
}
